'use strict';
define([
    'angular',
    'modules/settings/paymentsMethods/paymentsMethods.controller'
],function(angular,paymentsMethodsCtrl){
    var app=angular.module('settings.paymentsMethods', []);
    app.controller('paymentsMethodsCtrl',paymentsMethodsCtrl);
    return app;
});